import { useState, useEffect} from "react";
import {replace, useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import parse from 'html-react-parser';
import { Tooltip as ReactTooltip } from "react-tooltip";
import {search_zip} from '../API/APICalls';



type PersonalInfoProps = {
    
    handleClick: any
}

export default function Search ({handleClick}:PersonalInfoProps) {
    
    const navigate = useNavigate();
    const location = useLocation();
    
    //Set PAGE NAME for tracking 
    const zipsearch = location.state.zipcode;

    const [data, setData] = useState([]);
    const [zipcode, setZipcode] = useState(zipsearch || null);
    
    const [isLoading, setIsLoading] = useState(false);

    const fetchAPI = async () => {
       location.state.zipcode = "";
        
    //    const options = {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //           },
    //         url: process.env.REACT_APP_HOST+"/search_hs_zipcode",
    //         data: {'zipcode': zipcode},
    //         withCredentials: true
    //       }
    //       axios.request(options)
    //       .then(function (response) {            
    //         if (response.data.results !== "No Results")
    //         {
    //           setData(response.data.results)
    //           navigate(".", { replace: true, state: { zipcode:zipcode, mode:location.state.mode, aga:response.data.results, inputs:'' } })
    //           setIsLoading(false);   
                
    //         } else {
    //             setIsLoading(false);
    //             setData([]);
    //         }
    //       })
    //       .catch(function (error) {
    //           console.error(error);

    //       })
    
        
        const zipcodes = await search_zip(zipcode);
        if (JSON.parse(zipcodes || '').results !== "No Results")
        {
            setData(JSON.parse(zipcodes || '').results);
            navigate(".", { state: { zipcode:zipcode, mode:location.state.mode, aga:JSON.parse(zipcodes || '').results, inputs:'' } })
            setIsLoading(false);      
        } else {
            setIsLoading(false);
            setData([]);
        }


      };



    useEffect(() => {
        document.title = 'Get a Handicap - Search Zipcode';
        sessionStorage.removeItem("basket");
        handleClick(JSON.parse(sessionStorage.getItem("basket") || '0'));

        setIsLoading(true);
        
        // var storedzipcode = location.state.aga;
        var storedzipcode = '';
       // console.log(storedzipcode);
       
       if (storedzipcode !== '')
        {     
            var hubspot_zip = location.state.zipcode || '[]';
            //console.log(hubspot_zip);
 
            if (hubspot_zip === zipcode)
            {
           
                setIsLoading(false);
                setData(location.state.aga);
            } else {
                
                fetchAPI();
            }
        } else {
            fetchAPI();
        }      
      },[]);


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
       // location.state.zipcode = event.currentTarget.value;
        
        setZipcode(event.currentTarget.value);
    }

    const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
     
        //check session 
       // if (zipcode == JSON.parse(sessionStorage.getItem("data") || '').zipcode)
        if (zipcode === zipsearch)
        { 
            console.log("no change to zip code " + zipcode)
            setIsLoading(false);
        } else {
            fetchAPI();
            //sessionStorage.setItem("data", JSON.stringify({"zipcode": zipcode}));
            location.state.zipcode= zipcode;
            setZipcode(zipcode);
        }
       
      }


      const addtobasket = (event: React.LinkHTMLAttributes<HTMLButtonElement>) => {
        sessionStorage.setItem("basket", "1");

        handleClick(JSON.parse(sessionStorage.getItem("basket") || ''));
    
        navigate('/personal-lookup', {replace:true, state: {zipcode:zipcode, aga:data, inputs: ''}});
         
      }
      

      

    return (<>
        <div className="container page_container mb-5">
        <div className="col-12 mx-auto">
            <div className="col-12 col-sm-12 text-center"><h1 className="">Find Your Allied Golf Association (AGA)</h1></div>
            <div className="row">
                <div className="col-12 col-lg-5 mx-auto">
                <label>Billing Zip Code* <i className="bi bi-info-circle" data-tooltip-id="zipcode-tooltip"></i></label>
                <ReactTooltip
                      id="zipcode-tooltip"
                      place="top"
                      content="Please use the ZIP Code and address linked to your credit card."
                    />
                <form onSubmit={handleSearch} >
                <div className="input-group my-3">
                    <input type="text" className="form-control" name="zipcode" value={zipcode} onChange={handleChange} pattern="[0-9]+" minLength={5} maxLength={5} onInvalid={(e) =>
    e.currentTarget.setCustomValidity('Please Enter a Valid 5 digit Zip Code')
  } onInput={(e) => e.currentTarget.setCustomValidity('')}></input>
                    <button className="btn btn-primary rounded-pill" type="submit" id="button-addon2">
                    {isLoading ?
                      <div className="spinner-border" role="status"></div>
                    : "SEARCH"
                    }
                    </button>
                </div>
                </form>
                </div>
            </div>
            
        </div>
        
        {isLoading ?
        <div className="loaderWrapper">
        <div className="loader"></div>
        </div>
        : ""
        }


        {data && data.length === 0 ?
            <h4 className="pt-5 text-center text-danger"><i className="bi bi-exclamation-circle"></i> Zip Code entered does not match our community database. <br />Re-enter Zip code or contact the <a className="text-danger" href="mailto:gcsupport@usga.org">USGA</a> for assistance.</h4>
    : ""}


{!isLoading && data && data.map((results,index) => (
        <div className="row my-3 pt-3" key={index}>
            <div className="col-12 col-sm-12 col-md-12 mx-auto">
                <h4 className="text-center fs-3">{results['aga_name']} supports the golf community in <b>{results['city']}, {results['state']}</b>.</h4>
            </div>
        </div> 
        )) }

    {!isLoading  && data !== undefined && data && data.map((results) => (
        <div className="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-10 border border-2 bg-body-white border-secondary-subtle mx-auto rounded" key="2">
        
{/* 
        This is for joint message between USGA and AGA. */
        
}

        {results['usga_aga_joint_membership'] == "Yes" ? 
            <div className="row pt-2">
            <div className="mt-3 col-11 col-sm-9 col-md-9 col-lg-9 col-xl-8 mx-auto pb-3"><img className="img-fluid ps-2" id="" style={{maxHeight:"200px"}} src={results['aga_logo_lockup']} alt={results['aga_logo_lockup']+" logo"}></img></div>
            <div className="px-3 col-11 col-sm-9 col-md-9 col-lg-9 col-xl-8 mx-auto"><h4 className="">{results['aga_name']}</h4></div>
            

            <div className="col-12">
                <div className="px-4 col-12 col-sm-9 col-md-9 col-lg-9 col-xl-8 mx-auto">
                    
                    <div className="fs-1 fw-bold">${Number.parseFloat(results['price_with_tax']).toFixed(2)}</div>
                    <div className="">For one-year joint USGA and {results['aga_name']} (365 days) membership</div>
                    <hr className="small_hr"/>
                    <div className="col-12 p-2" id="golferbenefits" key="benefits1">
                {parse(results['joint_membership_benefits'], {
  transform(reactNode, domNode, index) {
    // this will wrap every element in a div
    return <div key={index}>{reactNode}</div>;
  },
})}</div>

                   


                </div>
                <div className="col-9 col-sm-9 col-md-8 col-lg-8 col-xxl-8 mx-auto mb-4">
                        <button className="w-100 btn btn-primary rounded-pill btn-lg px-4" type="button" onClick={addtobasket}>
                            BECOME A MEMBER
                        </button>
                    </div>
            </div>
            </div>

        :
        
        <div className="row pt-2">
            <div className="col-3 col-sm-2 col-md-2 col-lg-2 col-xl-2 ms-2" id="logo-align">
                <img className="img-fluid ps-2" id="logo-img-align" src={results['aga_logo_url']} alt={results['aga_logo_url']+" logo"} />
            </div>
            <div className="col-8 col-sm-9 col-md-9 col-lg-9 col-xl-9" id="header-padding">
                <h4 className="">{results['aga_name']}</h4>
            </div>

        
    


        <div className="col-12">
            <div className="px-3 col-12 col-sm-9 col-md-9 col-lg-9 col-xl-8 mx-auto">
                
                <div className="fs-1 fw-bold">${Number.parseFloat(results['unit_price']).toFixed(2)}</div>
                <div className="">For one-year (365 days) membership to the {results['aga_club_name']}</div>
                <hr className="small_hr"/>
                <div className="col-12 p-2" id="golferbenefits" key="benefits">
                {parse(results['aga_benefits'], {
  transform(reactNode, domNode, index) {
    // this will wrap every element in a div
    return <div key={index}>{reactNode}</div>;
  },
})}</div>
            </div>

            

            <div className="px-3 col-12 col-sm-9 col-md-8 col-lg-8 col-xxl-8 mx-auto mb-4">
                    <button className="w-100 btn btn-primary rounded-pill btn-lg px-4" type="button" onClick={addtobasket}>
                        BECOME A MEMBER
                    </button>
                </div>
        </div>
        </div>
    }

   
    </div>
        
    )) }

    </div>

    </>

        
        
    
    )
}